import { createSlice } from '@reduxjs/toolkit';

const ReportData = {
  budget: '',
  description: '',
  domain: '',
  email: '',
  file: '',
  have_design: false,
  modules: [''],
  name: '',
  page_id: '',
  results: {
    fastest: {
      hours: 0,
      price_min: 0,
      price_max: 0,
      discovery: 0,
      design_min: 0,
      design_max: 0,
      accuracy: 0,
      people_in_team: 0,
      weeks_min: 0,
      weeks_max: 0,
      team: [
        {
          additionalProp1: {},
        },
      ],
      consultation_minutes: 0,
      system_discovery_days_min: 0,
      system_discovery_days_max: 0,
      design_days_min: 0,
      design_days_max: 0,
      system_development_days_min: 0,
      system_development_days_max: 0,
      system_improvement_days_min: 0,
      system_improvement_days_max: 0,
    },
    balanced: {
      hours: 0,
      price_min: 0,
      price_max: 0,
      discovery: 0,
      design_min: 0,
      design_max: 0,
      accuracy: 0,
      people_in_team: 0,
      weeks_min: 0,
      weeks_max: 0,
      team: [
        {
          additionalProp1: {},
        },
      ],
      consultation_minutes: 0,
      system_discovery_days_min: 0,
      system_discovery_days_max: 0,
      design_days_min: 0,
      design_days_max: 0,
      system_development_days_min: 0,
      system_development_days_max: 0,
      system_improvement_days_min: 0,
      system_improvement_days_max: 0,
    },
    advanced: {
      hours: 0,
      price_min: 0,
      price_max: 0,
      discovery: 0,
      design_min: 0,
      design_max: 0,
      accuracy: 0,
      people_in_team: 0,
      weeks_min: 0,
      weeks_max: 0,
      team: [
        {
          additionalProp1: {},
        },
      ],
      consultation_minutes: 0,
      system_discovery_days_min: 0,
      system_discovery_days_max: 0,
      design_days_min: 0,
      design_days_max: 0,
      system_development_days_min: 0,
      system_development_days_max: 0,
      system_improvement_days_min: 0,
      system_improvement_days_max: 0,
    },
  },
  stage: [''],
  time_period: '',
  type: '',
  _id: '',
};

const reportSlice = createSlice({
  name: 'report',
  initialState: {
    loading: false,
    success: false,
    failed: false,
    error: '',
    reportData: ReportData,
  },
  reducers: {
    fetchReportData(state) {
      state.loading = true;
      state.success = false;
      state.failed = false;
      state.error = '';
    },
    reportDataSuccess(state, { payload }) {
      state.success = true;
      state.failed = false;
      state.error = '';
      state.reportData = payload;
      state.loading = false;
    },
    reportDataError(state, { payload }) {
      state.success = false;
      state.failed = true;
      state.error =
        payload.data?.detail || payload || 'Sorry, report not found';
      state.loading = false;
    },
  },
});

export const { fetchReportData, reportDataSuccess, reportDataError } =
  reportSlice.actions;

export default reportSlice.reducer;
